module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['input-form-wrap-row', 'spacing-height', _vm.inputStyleClass]
  }, [_c('div', {
    staticClass: "input-label"
  }, [(_vm.required) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": _vm.placeholder,
      "size": "mini",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cebc0b96","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/orderCreate/SelectField.vue
// module id = 685
// module chunks = 0